import '../../_rollupPluginBabelHelpers-a38db067.js';
import '../utils.js';
import '../core/core-utils.js';
import '../core/parser.js';
import '../core/style-function.js';
import { system } from '../core/system.js';

const config = {
  fontFamily: {
    property: 'fontFamily'
  },
  fontSize: {
    property: 'fontSize'
  },
  fontStyle: {
    property: 'fontStyle'
  },
  fontWeight: {
    property: 'fontWeight'
  },
  letterSpacing: {
    property: 'letterSpacing'
  },
  lineHeight: {
    property: 'lineHeight'
  },
  textAlign: {
    property: 'textAlign'
  },
  textDecoration: {
    property: 'textDecoration'
  },
  textOverflow: {
    property: 'textOverflow'
  },
  textTransform: {
    property: 'textTransform'
  },
  whiteSpace: {
    property: 'whiteSpace'
  },
  wordBreak: {
    property: 'wordBreak'
  }
};
const typography = system(config);

export { typography };
